import React, { ReactElement } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/pl';

import { NewsItemInterface } from 'interfaces/news-item.interface';

import './news-article.scss';
import Link from 'atomic/link/link';
import classNames from 'classnames';

dayjs.locale('pl');

const NewsArticle: React.FC<{ newsItem: NewsItemInterface; asListItem?: boolean; }> = ({ newsItem, asListItem }): ReactElement => (
    <div className={classNames('news-article', { 'news-article--list-item': asListItem })}>
        <div className="news-article__header">
            {asListItem && (
                <h2 className="news-article__title">
                    <Link href={`/i/aktualnosci/${newsItem.slug}`} className="news-article__title-link">
                        {newsItem.title}
                    </Link>
                </h2>
            )}
            <div className="news-article__date">
                { dayjs(newsItem.createdAt).format('D MMMM YYYY') }
            </div>
        </div>
        <div className="news-article__body" dangerouslySetInnerHTML={{ __html: newsItem.content }} />
    </div>
);

export default NewsArticle;
